import { DTO } from "./database";
import { settingsModel } from "./settings";

const collection = "fields";
class FieldModel extends DTO {
  constructor(collection) {
    super(collection);
  }

  getFields(farmId) {
    return this.list("name", "farmId", "==", farmId).then(fields => fields.sort(this.sortFields));
  }

  getAllFieldServices(fields) {
    let services = [];
    fields.forEach(field => {
      if (field.services) {
        field.services.forEach(service => {
          const fieldServices = service.services || [];
          const fieldEquipment = service.equipment || [];
          const servicesSummary = fieldServices
            .map(service => service.name)
            .join(', ');

          const equipmentSummary = fieldEquipment
            .map(equipment => equipment.name)
            .join(', ');

          services.push({
            servicesSummary,
            equipmentSummary,
            farmName: field.farmName,
            fieldName: field.name,
            ...service
          });
        });
      }
    });
    return services.sort(this.sortServices);
  }

  getTotalArces(fields) {
    let arces = 0;
    fields.forEach(field => {
      if (field.arces) {
        arces += Number(field.arces);
      }
    });
    return arces;
  }

  getService(fieldId, serviceId) {
    return this.get(fieldId).then(field => {
      let found = {};
      const services = field.services || [];
      services.forEach(field => {
        if (field.id === serviceId) {
          found = field;
        }
      });

      if (found) {
        return found;
      }

      return Promise.reject("field not found");
    });
  }

  updateService(fieldId, serviceId, serviceData) {
    return this.get(fieldId).then(field => {
      const services = field.services || [];
      const currentServices = services.filter(service => {
        return service.id !== serviceId;
      });

      const updatedField = {
        ...serviceData,
        updatedAt: new Date(),
        updatedBy: this.getCurrentUserId()
      };
      currentServices.push(updatedField);
      field.services = currentServices;
      return this.update(fieldId, field);
    });
  }

  removeService(fieldId, serviceId) {
    return this.get(fieldId).then(field => {
      const services = field.services || [];
      const currentServices = services.filter(service => {
        return service.id !== serviceId;
      });

      field.services = currentServices;
      return this.update(fieldId, field);
    });
  }

  createService(fieldId, service) {
    let lastServiceNumber;
    return settingsModel
      .getServiceSettings()
      .then(serviceSettings => {
        lastServiceNumber = serviceSettings.lastServiceNumber + 1;
        const currentTime = new Date();
        const data = {
          ...service,
          fieldId,
          id: this.randomString(),
          reference: lastServiceNumber,
          createdAt: currentTime,
          createdBy: this.getCurrentUserId(),
          updatedAt: currentTime
        };
        return this.updateArray(fieldId, "services", data);
      })
      .then(() =>
        settingsModel.updateServiceSettings({
          lastServiceNumber
        })
      );
  }

  sortServices(a, b) {
    if (a.reference > b.reference) {
      return -1;
    }
    if (a.reference < b.reference) {
      return 1;
    }
    return 0;
  }

  sortFields(a,b){
    const number = Number(a.name);
    const secondNumber = Number(b.name);
    if (number < secondNumber) {
      return -1;
    }

    if (number > secondNumber) {
      return 1;
    }

    return 0;
  }
}

export const fieldsModel = new FieldModel(collection);
